import { createRemoteJWKSet, jwtVerify } from 'jose';
import { config } from '../global/config';
import { logTrace } from '../telemetry/logTrace';

const AUTOCONNECT_SESSION_PURPOSE = 'autoconnect-session';

let jwks: ReturnType<typeof createRemoteJWKSet> | undefined;

const getJwks = () => {
  jwks ??= createRemoteJWKSet(
    new URL(`${config.idpAuthority}/.well-known/openid-configuration/jwks`),
  );
  return jwks;
};

// Verifies the token was signed by the IdP's own signing key (the same one
// used/trusted for OIDC id_tokens) and hasn't expired, so the caller can
// trust it originated from a real IdP autoconnect redirect, not a crafted URL.
export const verifyAutoconnectSessionToken = async (
  token: string,
): Promise<boolean> => {
  try {
    const { payload } = await jwtVerify(token, getJwks(), {
      issuer: config.idpAuthority,
    });

    logTrace('verifyAutoconnectSessionToken: jwtVerify succeeded', {
      purpose: payload.purpose,
      iss: payload.iss,
      exp: payload.exp,
      nowSeconds: Math.floor(Date.now() / 1000),
      expectedIssuer: config.idpAuthority,
    });

    return payload.purpose === AUTOCONNECT_SESSION_PURPOSE;
  } catch (err) {
    logTrace('verifyAutoconnectSessionToken: jwtVerify threw', {
      name: err instanceof Error ? err.name : typeof err,
      message: err instanceof Error ? err.message : String(err),
      expectedIssuer: config.idpAuthority,
      jwksUrl: `${config.idpAuthority}/.well-known/openid-configuration/jwks`,
    });
    return false;
  }
};
